module.exports = __webpack_public_path__ + "img/hedgehog-7922370_1280.c18983f1.jpg";